// frontend/src/routes/LandingGate.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LandingPage from '../components/landing/LandingPage';

// Clerk keeps __client_uat on the app's domain: 0 when signed out, the sign-in time when signed in.
// A first-time visitor has none.
const looksSignedOut = () => {
    const match = document.cookie.match(/(?:^|;\s*)__client_uat=([^;]*)/);
    return !match || match[1] === '0';
};

// Shows the public landing page (YES-276) to signed-out visitors on "/" only, outside the app shell.
// Everyone else, and every other path, gets the app and its routes unchanged. While Clerk is still
// loading (isAuthenticated undefined), the cookie decides, so visitors see the page without waiting
// for Clerk; once Clerk has loaded, its answer wins.
const LandingGate = ({ children }) => {
    const { pathname } = useLocation();
    const { isAuthenticated } = useAuth();

    const signedOut = isAuthenticated === false || (isAuthenticated === undefined && looksSignedOut());

    if (pathname === '/' && signedOut) {
        return <LandingPage />;
    }

    return children;
};

export default LandingGate;
